import React, { useState } from "react";
import { Card, Typography, Divider } from "@mui/material";
import PropTypes from "prop-types";
import FormStaffInfoField from "../../../FormFields/StaffInfoField/FormStaffInfoField";
import { formCardStyle } from '../../../TransitionStyles';
import { DIETARY } from '../../../formQuestionsEnum';

DietaryDirectorForm.propTypes = {
  permissions: PropTypes.object
}

export default function DietaryDirectorForm({permissions}) {
  const [focusedField, setFocusedField] = useState(null);

  const fieldIds = [
    DIETARY.DIETARY_DIRECTOR.id
  ]

  const showForm = fieldIds.some(id => id in permissions);

  return showForm &&
    <Card sx={formCardStyle}>
      <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
        Dietary director
      </Typography>
      <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />

      {DIETARY.DIETARY_DIRECTOR.id in permissions && 
        <FormStaffInfoField
          fieldName={DIETARY.DIETARY_DIRECTOR.fieldName}
          fieldAttributes={{
            isEditable: permissions[DIETARY.DIETARY_DIRECTOR.id],
            questionTitle: 'Dietary director',
            fieldName: DIETARY.DIETARY_DIRECTOR.fieldName,
          }}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      }

    </Card>
};